import { Component, OnInit } from '@angular/core';
import {Platform} from '@angular/cdk/platform';
import {Router} from '@angular/router';
import {environment} from '../../../../environments/environment';

@Component({
  selector: 'app-mex',
  templateUrl: './mex.component.html',
  styleUrls: ['./mex.component.scss']
})
export class MexComponent implements OnInit {

  constructor(public platform: Platform, protected router: Router) {
  }

  ngOnInit(): void {
    if (this.platform.IOS) {
      window.location.href = `${environment.mexIosStore}`;
    }
    if (this.platform.ANDROID) {
      window.location.href = `${environment.mexAndroidStore}`;
    }
    if (!this.platform.IOS && !this.platform.ANDROID) {
      this.router.navigateByUrl('/');
    }
  }

}
